import React, { Fragment } from 'react';

import { Container } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles'

import { PatronAppBar } from '../components/PatronAppBar'
import PoolPassTheme from '../Theme'

export default function Terms(props) {

    const isMobile = window.innerWidth < 916; 
      
    const iframeStyle = {
        flexGrow: 1, 
        border: 'none',
        width: '100%',
        height: window.innerHeight * .77,
        marginTop: 10,
        padding: 0
    };
    

    return (
                 
        <ThemeProvider theme={PoolPassTheme}>
            <Fragment>

                <PatronAppBar isMobile={isMobile}/>

                <Container maxWidth='lg'>
                    <iframe title="Terms and Conditions" style={iframeStyle} src={props.source}></iframe> 
                </Container>
            </Fragment>
        </ThemeProvider>    

    );
       
}